/*eslint-disable*/
import React from "react";

// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
// import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import SectionPillsTribalism from "pages-sections/blog-posts/SectionPillsTribalism.js";
import Footer from "components/Footer/TribalismFooter.js"

import SectionImage from "pages-sections/blog-posts/SectionImage.js";
import SubscribeLine from "pages-sections/blog-posts/SubscribeLine.js";
import styles from "../pages-sections/services/ServicesSections.module.scss";



export default function BlogPostsPage() {


  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;

  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Our Blog - Tribalism"
        image="/img/bg10-small.webp"
        url="https://www.tribalism.com.au/blog"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Read through some of our insights in Data Analytics and Digital Marketing !"
        changeColorOnScroll={{
          height: 400,
          color: "info",
        }}
      />
      <Parallax image="/img/bg10-sm.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
              <h2 className={classes.titleWhite}>
                Our insights from the world of digital experience, analytics and marketing
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main} >
        <div className={classes.container}>
         <SectionPillsTribalism/>
          
        </div>
        <SectionImage />
        <SubscribeLine />
      </div>
      <Footer
        
      />
    </div>
  );
}
